import { Component, Vue } from 'vue-property-decorator';
import {
  notifications_store, global_store, user_store, events_calendar_store,
} from '@/store';
import { Clients } from '@/modules/clients/types';
import { Cart } from '@/modules/cart/types';
import { Leads } from '@/modules/leads/types';
import { Orders } from '@/modules/orders/types';
import { Repairs } from '@/modules/repairs/types';
import { Dispatches } from '@/modules/dispatches/types';
import { Staffs } from '@/modules/staffs/types';
import { News } from '@/modules/news/types';
import { NotificationsSlugs } from '@/enums';
import { SoftwareLicenses } from '@/modules/software-licenses/types';
import { Projects } from '@/modules/projects/types';
import { Patchnotes } from '@/modules/patchnotes/types';
import { EventsCalendar } from '@/modules/events-calendar/types';
import { PurchaseOrders } from '@/modules/purchase-orders/types';
import { DataPilot } from '@/modules/data-pilot/types';
import { Notifications } from '../types';

const { actions } = notifications_store;

@Component
export default class GetRouteSlugMixin extends Vue {
  get_route_slug(slug: string) {
    switch (slug) {
      case NotificationsSlugs.CLIENT:
        return Clients.Pages.CLIENT_DETAIL;
      case NotificationsSlugs.CART:
        return Cart.Pages.DETAIL;
      case NotificationsSlugs.LEAD:
        return Leads.Pages.LEAD_DETAIL;
      case NotificationsSlugs.LEAD_HISTORY:
        return Leads.Pages.LEAD_DETAIL;
      case NotificationsSlugs.LEAD_REMINDER:
        return Leads.Pages.LEAD_DETAIL;
      case NotificationsSlugs.ORDER:
        return Orders.Pages.ORDER_DETAIL;
      case NotificationsSlugs.ORDER_SIDE_NEW:
        return Repairs.Pages.REPAIR_DETAIL;
      case NotificationsSlugs.ORDER_SIDE_exist:
        return Repairs.Pages.REPAIR_DETAIL;
      case NotificationsSlugs.REALIZATION:
        return Dispatches.Pages.DISPATCH_DETAIL;
      case NotificationsSlugs.STAFF:
        return Staffs.Pages.STAFF_DETAIL;
      case NotificationsSlugs.CERTIFICATION:
        return Staffs.Pages.STAFF_DETAIL;
      case NotificationsSlugs.CERTIFICATION_OWNER:
        return Staffs.Pages.STAFF_DETAIL;
      case NotificationsSlugs.ORDER_SIDE_NOT_SIGNED_DOCUMENT_UPLOADED:
        return Repairs.Pages.REPAIR_DETAIL;
      case NotificationsSlugs.NEWS_PUBLISHED:
        return News.Pages.NEWS_DETAIL;
      case NotificationsSlugs.NEWS:
        return News.Pages.NEWS_DETAIL;
      case NotificationsSlugs.EVENT:
        return News.Pages.NEWS_DETAIL;
      case NotificationsSlugs.SOFTWARE_LICENSES:
        return SoftwareLicenses.Pages.SOFTWARE_LICENSE_DETAIL;
      case Projects.Pages.PROJECT_DETAIL:
        return Projects.Pages.PROJECT_DETAIL;
      case NotificationsSlugs.PATCH_NOTES:
        return Patchnotes.Pages.PATCHNOTES;
      case NotificationsSlugs.CALENDAR:
        return EventsCalendar.Pages.CALENDAR;
      case NotificationsSlugs.PURCHASE_ORDERS:
        return PurchaseOrders.Pages.PURCHASE_ORDER_DETAIL;
      case NotificationsSlugs.SMART_RADAR:
        return DataPilot.Pages.DATA_PILOT;

      default:
        return '';
    }
  }

  go_to_notification_detail(item: Notifications.Notification) {
    if (!item.is_read && item.id) {
      actions.reading_notifs([item.id]);
      user_store.actions.get_user_info();
    }

    // условие для параметра роута, необходимое для открытия определенного таба в компоненте
    const tab_values: { [key: string]: boolean } = {
      [NotificationsSlugs.LEAD_HISTORY]: true,
      [NotificationsSlugs.ORDER]: true,
      [NotificationsSlugs.ORDER_SIDE_NOT_SIGNED_DOCUMENT_UPLOADED]: true,
    };
    const tab = tab_values[item.section.slug] || false;
    const route_name = this.get_route_slug(item.section.slug);

    // условие для перехода по внешней ссылке
    if (item.section.slug === NotificationsSlugs.CALENDAR && item.additional_data?.url && item?.reference_id) {
      const url = String(item.additional_data.url);
      // формируем payload для статистики
      const payload_stat_event = {
        event_id: Number(item.reference_id),
        slug: item.additional_data.type,
        user_agent: window.navigator.userAgent,
      };

      if (url) {
        events_calendar_store.actions.statistics_sent(payload_stat_event);
        window.open(url, '_blank');
        return;
      }
    }

    if (
      this.$route.name === route_name
      && this.$route.params.id === `${item.reference_id}`
    ) {
      global_store.mutations.NOTIFICATIONS_BAR_TOGGLE(false);
      return;
    }

    this.$router.push({
      name: `${this.get_route_slug(item.section.slug)}`,
      params: { id: `${item.reference_id}`, tab: tab.toString() },
      ...(item.section.slug === NotificationsSlugs.SMART_RADAR && {
        query: {
          client_id: item.reference_id.toString(),
        },
      }),
    });

    global_store.mutations.NOTIFICATIONS_BAR_TOGGLE(false);
  }
}
